<section class="border-border mb-3" (click)="onClick($event)">
  <div *ngIf="showAlsoTables && alsoTableNames" class="mb-2">
    <p><span class="thin">Also tables:</span> {{ alsoTableNames }}</p>
  </div>

  <div class="chip space" [style.background]="chipColor">
    <span>{{ chipText }}</span>
  </div>

  <div class="header">
    <div class="d-flex flex-row justify-content-between align-items-center w-100">
      <div class="d-flex flex-row justify-content-start align-items-center">
        <p class="color-primary-text mr-2" [innerText]="name"></p>
        <tablesready-party-badge
          [party]="partyBadge"
          [showTypeBadge]="partyBadge.type === partyTypes.reservation && type === floorPlanPartyTypes.serving"
        ></tablesready-party-badge>
        <shared-badge
          *ngIf="unpaid"
          [label]="'Unpaid'"
          [class]="'badge badge-pill badge-danger'"
        ></shared-badge>
        <shared-badge
          *ngIf="paid"
          [label]="'Paid'"
          [class]="'badge badge-pill badge-success'"
        ></shared-badge>
      </div>

      <div class="d-flex align-items-center">
        <tr-icon [icon]="icon.customers"></tr-icon>
        <p class="guests ml-2">{{ size }} guests</p>
      </div>
    </div>
  </div>

  <div *ngIf="unpaid" class="d-flex flex-row align-items-center justify-content-start font-weight-bold sapce">
    <span class="pr-1">
      Holding for:
    </span>
    <tablesready-countdoun-timer [milliseconds]="remainingSecondsToPay"></tablesready-countdoun-timer>
  </div>

  <div class="time d-flex align-items-center">
    <tablesready-table-time
      [type]="type"
      [iconColor]="iconColor"
      [checkInTime]="party.checkin_time"
      [seatedTime]="party.seated_time"
      [quotedTime]="party.quoted_time"
      [duration]="party.duration"
      [timezone]="timezone"
      colorClass=""
    ></tablesready-table-time>
  </div>

  <div class="space" *ngIf="paid && party.stripeData?.paymentLink">
    <a class="text-link" [href]="party.stripeData?.paymentLink" target="_blank">Manage Payment</a>
  </div>

  <div class="phone space d-flex align-items-center" *ngIf="party.phone">
    <tr-icon [icon]="icon.call" class="mr-2"></tr-icon>
    <p>{{ party.phone | trTel: country:'custom' }}</p>
  </div>

  <div class="d-flex justify-content-between w-100 align-items-start">
    <button class="space btn btn-link-danger" (click)="deleteParty.emit()">Delete</button>

    <div class="notifications pr-2 pb-2">
      <tablesready-waitlist-notify
        [hideButtons]="true"
        [timezone]="timezone"
        [party]="party"
        [notificationTime]="notificationTime"
        [voicePageNotificationEnabled]="voicePageNotificationEnabled"
        [notifyActions]="notifyActions"
        [isMobile]="isMobile"
      >
      </tablesready-waitlist-notify>
    </div>
  </div>

  <div class="actions mb-3">
    <button
      *ngFor="let action of actions; let i = index"
      (click)="action.action(party)"
      [class.mr-2]="i !== actions.length"
      [style.width]="action.buttonWidth ? action.buttonWidth : '100%'"
      [ngbTooltip]="action?.isDisabled && action.isDisabled(party) ? action.disabledTooltip : action.tooltip"
      [disabled]="action?.isDisabled ? action.isDisabled(party) : false"
      class="btn btn-{{ action.buttonStyle }} d-flex align-items-center justify-content-center"
    >
      <ng-container *ngIf="action.title">{{ action.title }}</ng-container>
      <tr-icon
        *ngIf="action.icon !== undefined"
        [icon]="action.icon"
        [color]="action.color ? action.color : iconColors.white"
        [class.ml-2]="action.title"
      ></tr-icon>
    </button>
  </div>
</section>
